<div
  class="getting-started-container"
  *ngrxLet="mazChatEnabled$ as mazEnabled"
  [class.maz-disabled]="!mazEnabled"
  ninetyStopPropagation
  (ninetyClickOutside)="close()"
  data-cy="getting-started-guide-modal">
  <div class="phases-container" *ngrxLet="selectedPhase$ as phase" [class.phase-selected]="phase">
    @if (!phase) {
      <ninety-phase-list />
    } @else {
      <ninety-phase-details [phase]="phase" [mazChatEnabled]="mazEnabled" />
    }
  </div>
  @if (mazEnabled) {
    <div class="maz-footer">
      <div
        class="maz-chat-panel"
        [@toggleMazChat]="(isMazChatExpanded$ | ngrxPush) ? 'expanded' : 'collapsed'"
        data-cy="maz-chat-panel">
        <ninety-maz-chat />
      </div>
    </div>
  }
</div>
